import { render, staticRenderFns } from "./PlanejamentoAcaoFormAnexoArquivo.vue?vue&type=template&id=1f94452e&scoped=true"
import script from "./PlanejamentoAcaoFormAnexoArquivo.vue?vue&type=script&lang=js"
export * from "./PlanejamentoAcaoFormAnexoArquivo.vue?vue&type=script&lang=js"
import style0 from "./PlanejamentoAcaoFormAnexoArquivo.vue?vue&type=style&index=0&id=1f94452e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f94452e",
  null
  
)

export default component.exports